/* 赛事接口*/
import { axios } from '@/utils/http'

// 赛事分类
export const getCategoryList = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/competition/category')

export const getCompetitionList = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/competition/list?' + params)
// 新增 收藏 浏览记录
export const addBrowserAndBookmark = (params) => axios({
  method: 'POST',
  contentType: 'jsonArray',
  data: {},
  noToast: true,
  hastoken: true
}, 'member/record/addBrowserAndBookmark?' + params)
// 收藏
export const addBookmark = (params) => axios({
  method: 'POST',
  contentType: 'jsonArray',
  data: {},
  noToast: true,
  hastoken: true
}, 'member/record/addBookmark?' + params)
// 浏览
export const addBrowser = (params) => axios({
  method: 'POST',
  contentType: 'jsonArray',
  data: {},
  noToast: true,
  hastoken: true
}, 'member/record/addBrowser?' + params)
// 查看我的浏览记录 收藏记录
export const getBrowserAndBookmark = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, 'member/record/getBrowserAndBookmark?' + params)
// 查看我的参与
export const getMyCompetition = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, 'member/record/getMyCompetition?' + params)

export const getCompetitionListForZone = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/competition/zone/competitions?' + params)
// 获取比赛详情
export const getCompetitionInfo = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/competition/detail?' + params)

// 获取用户协议和参赛须知
export const getSignupTemplate = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/competition/signup/template/getSignupTemplate?' + params)

export const historyQueryById = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/competition/history/queryById?' + params)

export const fetchWorkInfo = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/member/signup/unLoginRecord?' + params)

export const submitWork = (params) => axios({
  method: 'POST',
  contentType: 'jsonArray',
  data: params,
  noToast: true,
  hastoken: true
}, '/member/signup/submitWork')

// 提交报名接口
export const competitionSub = (params) => axios({
  method: 'POST',
  contentType: 'jsonArray',
  data: params,
  noToast: true,
  hastoken: true
}, 'competition/signup/submit')

// 校验是否已经报过名了
export const verifyUserInfo = (params) => axios({
  method: 'POST',
  contentType: 'jsonArray',
  data: params,
  noToast: true,
  hastoken: true
}, 'competition/signup/verifyUserInfo')

// 年级组别
export const getGroupList = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/competition/signup/group')

export const previewStInfo = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/competition/preview/detail?' + params)

// 获取赛题团队列表
export const teamList = (params) => axios({
  method: 'GET',
  noToast: true,
  hastoken: true
}, 'competition/signup/team?' + params)

// 申请加入团队
export const joinTeam = (params) => axios({
  method: 'POST',
  contentType: 'jsonArray',
  data: params,
  noToast: true,
  hastoken: true
}, 'competition/signup/apply')

export const uploadFile = (params) => axios({
  method: 'POST',
  contentType: 'formData',
  data: params,
  noToast: true,
  hastoken: true
}, 'competition/file/uploadFile')

export const getTechnicalList = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/competition/technical')

export const getCollegeList = () => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/college/query')

export const getRecommendationList = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/competition/competitions/recommend?' + params)

export const addSource = (params) => axios({
  method: 'POST',
  contentType: 'formData',
  data: params,
  noToast: true,
  hastoken: false
}, '/competition/source/add')

// Get competition hosting history
export const getCompetitionHostingHistory = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/competition/list?isManaged=1&isAll=1' + (params ? '&' + params : ''))

// 获取报名模板
export const queryByParentId = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/competition/signup/template/getSignupTemplate?' + params)

// 获取是否需要二要素验证
export const boolAuth = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/auth/verification/boolAuth?' + params)

// 二要素验证
export const verifyTwo = (params) => axios({
  method: 'POST',
  contentType: 'jsonArray',
  data: params,
  noToast: true,
  hastoken: true
}, '/auth/verification/two')

export const checkMember = (params) => axios({
  method: 'POST',
  contentType: 'jsonArray',
  data: params,
  noToast: true,
  hastoken: true
}, '/competition/signup/checkMember')

export const getAllSession = (params) => axios({
  method: 'GET',
  contentType: 'urlencoded'
}, '/competition/session/getAll?' + params)

export const UpdateCompetitionTemplateAssociation = (params) => axios({
  method: 'PUT',
  contentType: 'json',
  data: {
    ...params
  },
  noToast: true,
  hastoken: true
}, '/competition/UpdateCompetitionTemplateAssociation')
